/**
 * M6 Share & Embed — CLIENT-SAFE surface. These modules are browser-safe
 * (pure or js-sha256) so client components (the share modal, embed builder,
 * export dialog) can import them freely. The server-only repo + slug service
 * (Postgres / node:crypto) live in `@/lib/share/server` — importing THIS
 * barrel never pulls a server dependency into the client bundle.
 */

export { toKml, type KmlOptions } from "./kml";
export { toGeoJson, type GeoJsonOptions } from "./geojson";
export { buildMapPdf, type MapPdfInput } from "./pdf";
export {
  buildSnapshot,
  snapshotEtag,
  assertViewerSafe,
  SNAPSHOT_SCHEMA_VERSION,
  type MapSnapshot,
  type SnapshotMeta,
} from "./snapshot";
export {
  readShareGate,
  deriveShareGate,
  type ShareGate,
  type ShareGateDecision,
  type GateIdentity,
} from "./gate";
export { buildViewerMeta, isIndexable, type ViewerMeta, type ViewerMetaInput } from "./meta";
export { pointSetFromSnapshot } from "./render";
export {
  referrerHost,
  isShareEventType,
  SHARE_EVENT_TYPES,
  type ShareEventType,
  type ShareEventSurface,
} from "./events";
export {
  viewerCacheHeaders,
  VIEWER_CACHE_CONTROL,
  etagMatches,
  viewerHtmlPath,
  type ViewerCacheHeaders,
} from "./cdn";
